<script>
import { defineComponent } from "vue";
import TextInput from "../../../../../Comps/Forms/TextInput.vue";
import ModalTemplate from "../../../../../Comps/Master/ModalTemplate.vue";
import TextArea from "../../../../../Comps/Forms/TextArea.vue";
import AutoComplete from "../../../../../Comps/Forms/AutoComplete.vue";
import ComboBox from "../../../../../Comps/Forms/ComboBox.vue";

export default defineComponent({
    name: "SupplierCreateModal",
    components: { ComboBox, AutoComplete, TextArea, ModalTemplate, TextInput },
    data() {
        return {
            form: this.$inertia.form({}),
            modal: false,
        };
    },

    methods: {
        edit(supplier) {
            this.modal = true;
            this.form = this.$inertia.form(supplier);
            this.form.supplier_tags =
                supplier.supplier_tags?.map((tag) => tag.name) || [];
        },

        create() {
            this.modal = true;
            this.form = this.$inertia.form({
                id: "",
                name: "",
                email: "",
                phone: "",
                contact_name: "",
                website: "",
                street: "",
                city: "",
                postcode: "",
                notes: "",
                supplier_tags: [],
            });
        },

        async submit() {
            if (!(await this.$refs.validation.validate())) {
                return;
            }

            if (this.form.id) {
                this.form.put(this.route("suppliers.update", this.form.id), {
                    onSuccess: () => {
                        this.modal = false;
                    },
                });

                return;
            }

            this.form.post(this.route("suppliers.store"), {
                onSuccess: () => {
                    this.modal = false;
                },
            });
        },
    },
});
</script>

<template>
    <modal-template v-model="modal">
        <div class="text-h6 text--secondary mb-2 mt-2">
            {{ form.id ? "Edit" : "Create" }} a Supplier
        </div>

        <form novalidate @submit.prevent="submit">
            <validation-observer ref="validation">
                <v-row>
                    <v-col cols="12">
                        <text-input
                            autofocus
                            name="Company Name"
                            required
                            rules="required"
                            v-model="form.name"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <text-input
                            name="Contact Name"
                            v-model="form.contact_name"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <text-input
                            name="Email"
                            type="email"
                            v-model="form.email"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <text-input name="Phone" v-model="form.phone" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <text-input name="Website" v-model="form.website" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <text-area
                            name="Street Address"
                            v-model="form.street"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <text-input name="City" v-model="form.city" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <text-input name="Postcode" v-model="form.postcode" />
                    </v-col>
                </v-row>

                <v-divider class="my-6" />

                <v-row>
                    <v-col cols="12">
                        <combo-box
                            v-model="form.supplier_tags"
                            name="Tags"
                            :items="$page.props.supplierTags"
                            chips
                            small-chips
                            multiple
                            persistent-hint
                            hint="Tag this supplier with the services they can provide.  To add a new tag, type the name and press enter."
                        />
                    </v-col>
                    <v-col cols="12">
                        <text-area name="Notes" v-model="form.notes" />
                    </v-col>
                </v-row>
            </validation-observer>

            <v-btn
                color="success"
                type="submit"
                class="mt-6"
                :loading="form.processing"
            >
                Save
            </v-btn>
        </form>
    </modal-template>
</template>

<style scoped></style>
